import React from "react";
import { ScrollReveal } from "./ui/ScrollReveal";

export const JourneySection: React.FC = () => {
  return (
    <ScrollReveal delay={0.1}>
      <section className="py-24 bg-[#FAFAFA] px-2 lg:px-12" id="journey">
        <div className="container mx-auto px-6 text-center mb-16 w-[90%] md:w-[70%]">
          <p
            className="max-w-4xl mx-auto py-2 text-2xl md:text-3xl lg:text-heading-large bg-gradient-to-r
          from-[#e20016] from-[0%]
          via-[#712f59] via-[40%]
          to-[#005d9c] to-[100%] bg-clip-text text-transparent leading-tight lg:leading-[3.5rem] font-bold font-open-sans-hebrew"
          >
            A Journey Crafted Through Experience, Innovation, And Progress
          </p>
          <p className="text-gray-500 text-body mt-4 max-w-xl mx-auto font-raleway">
            From our 1985 beginning to today's advanced facility, our journey
            reflects industry leadership, global exposure, national recognition,
            and continuous innovation.
          </p>
        </div>

        <div className="container mx-auto pb-8 w-[90%] md:w-[70%]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 items-stretch">
            {[
              {
                year: "1985",
                title: "First Manufacturing Unit Established",
                desc: "Virgo Panel Product began plywood manufacturing in Punjab, marking the start of a strong industry legacy.",
              },
              {
                year: "2000",
                title: "Industry Leadership & Association Roles",
                desc: "Naresh Tewari served as Unopposed President, Northern India Plywood Manufacturers Association (representing ~700 units).",
              },
              {
                year: "National Recognition",
                title: "Appointment to IPIRTI Governing Body",
                desc: "Government recognized his expertise and appointed him to IPIRTI's influential Governing Body.",
              },
              {
                year: "2010",
                title: "Expansion & Modernization",
                desc: "Significant upgrades to manufacturing facilities to incorporate automated processes.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-xl sm:rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow grid grid-rows-[1fr_1fr] min-h-[280px] sm:min-h-[320px]"
              >
                <div className="p-6 flex items-center justify-center">
                  <span
                    className="p-2 w-full text-2xl sm:text-3xl lg:text-4xl bg-gradient-to-r
                from-[#e20016] from-[0%]
                via-[#712f59] via-[40%]
                to-[#005d9c] to-[100%] bg-clip-text text-transparent block italic text-center font-bold font-open-sans-hebrew"
                  >
                    {item.year}
                  </span>
                </div>
                <div className="p-6 pt-0 flex flex-col justify-start">
                  <h3 className="text-card-title font-medium text-gray-900 mb-3 font-raleway">
                    {item.title}
                  </h3>
                  <p className="text-body text-gray-500 font-raleway">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};
